var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "internal-page-main-section col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "gallety-main-section col-12 float-l" }, [
            _c("div", { staticClass: "row" }, [
              _c("ul", { staticClass: "portfolio-categ filter" }, [
                _c("li", { staticClass: "photovideo cat-item-1 active" }, [
                  _c(
                    "a",
                    {
                      attrs: { id: "photo", title: "Photos" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.photoVideoToggle($event)
                        }
                      }
                    },
                    [_vm._v("Photos")]
                  )
                ]),
                _vm._v(" "),
                _c("li", { staticClass: "photovideo cat-item-2" }, [
                  _c(
                    "a",
                    {
                      attrs: { id: "video", title: "Videos" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.photoVideoToggle($event)
                        }
                      }
                    },
                    [_vm._v("Videos")]
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "cat-section-mobile float-l width-full" },
                [
                  _c("h6", { staticClass: "float-l" }, [
                    _vm._v(" Select Categories")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "cat-section-mobile float-l width-full" },
                    [
                      _c("v-select", {
                        attrs: {
                          name: "mainCategoryId",
                          id: "mainCategoryId",
                          label: "text",
                          searchable: false,
                          filterable: false,
                          options: _vm.mainCategoryArr,
                          placeholder: "Select Category"
                        },
                        model: {
                          value: _vm.mainCategoryId,
                          callback: function($$v) {
                            _vm.mainCategoryId = $$v
                          },
                          expression: "mainCategoryId"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "float-l width-full" },
                    [
                      _c(
                        "li",
                        {
                          class:
                            "category category_" +
                            _vm.responsiveAllTab +
                            " active",
                          on: {
                            click: function($event) {
                              return _vm.getImages(_vm.responsiveAllTab)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(_vm.responsiveCategoryName) + " ")]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.subCategoryArr, function(categoryData, index) {
                        return [
                          _c(
                            "li",
                            {
                              class: "category category_" + categoryData.value,
                              on: {
                                click: function($event) {
                                  return _vm.getImages(
                                    categoryData.value,
                                    "sub"
                                  )
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(categoryData.text) + " ")]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "bottom-gallery-detail-main col-12 float-l" },
                [
                  _c(
                    "div",
                    { staticClass: "row" },
                    [
                      _c(
                        "p",
                        { staticClass: "gallery-title float-l width-full" },
                        [_vm._v(" " + _vm._s(_vm.categoryName) + " ")]
                      ),
                      _vm._v(" "),
                      _vm.categoryDescription != ""
                        ? [
                            _c(
                              "p",
                              { staticClass: "gallery-title-description" },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.categoryDescription) + " "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "clearfix" })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "portfolio-content col-12 col-sm-9 col-md-9 col-lg-9"
                        },
                        [
                          _c("div", { staticClass: "row" }, [
                            _c(
                              "ul",
                              { staticClass: "portfolio-area" },
                              [
                                _vm._l(_vm.imageList, function(text, index) {
                                  return [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "portfolio-common portfolio-photo portfolio-item2 col-12 col-sm-4 col-md-4 col-lg-4",
                                        attrs: {
                                          "data-id": "id-1",
                                          "data-type": "cat-item-1"
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "image-block" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "hover-home-eefect employee-border"
                                                },
                                                [
                                                  _c(
                                                    "a",
                                                    {
                                                      staticClass: "image-zoom",
                                                      attrs: {
                                                        href: text.image,
                                                        rel:
                                                          "prettyPhoto[gallery]",
                                                        title: text.caption
                                                      }
                                                    },
                                                    [
                                                      _c("img", {
                                                        attrs: {
                                                          src: text.image
                                                        }
                                                      })
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.captionTrim(
                                                      text.caption
                                                    )
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    (Number(index) + 1) % 3 == 0
                                      ? [_c("div", { staticClass: "clearfix" })]
                                      : _vm._e()
                                  ]
                                }),
                                _vm._v(" "),
                                _vm._l(_vm.videoList, function(text, index) {
                                  return [
                                    _c(
                                      "li",
                                      {
                                        staticClass:
                                          "portfolio-common portfolio-video portfolio-item2 col-12 col-sm-4 col-md-4 col-lg-4",
                                        staticStyle: { display: "none" },
                                        attrs: {
                                          "data-id": "id-1",
                                          "data-type": "cat-item-2"
                                        }
                                      },
                                      [
                                        _c("div", [
                                          _c(
                                            "span",
                                            { staticClass: "image-block" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "hover-home-eefect employee-border"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "video-popup"
                                                    },
                                                    [
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              "#myModal_" +
                                                              text.id,
                                                            "data-toggle":
                                                              "modal"
                                                          }
                                                        },
                                                        [
                                                          text.type == "video"
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src:
                                                                      text.image,
                                                                    alt:
                                                                      text.type
                                                                  }
                                                                })
                                                              ]
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          text.type == "url"
                                                            ? [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src:
                                                                      "/static/images/video.jpg",
                                                                    alt:
                                                                      text.type
                                                                  }
                                                                })
                                                              ]
                                                            : _vm._e()
                                                        ],
                                                        2
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass: "modal fade",
                                                      attrs: {
                                                        id: "myModal_" + text.id
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "modal-dialog"
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "modal-content"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "modal-header"
                                                                },
                                                                [
                                                                  text.caption !=
                                                                  ""
                                                                    ? [
                                                                        _c(
                                                                          "h4",
                                                                          {
                                                                            staticClass:
                                                                              "modal-title"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                text.caption
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : [
                                                                        _c(
                                                                          "h4",
                                                                          {
                                                                            staticClass:
                                                                              "modal-title"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                text.category_name
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ],
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "button",
                                                                    {
                                                                      staticClass:
                                                                        "close",
                                                                      attrs: {
                                                                        type:
                                                                          "button",
                                                                        "data-dismiss":
                                                                          "modal",
                                                                        "aria-hidden":
                                                                          "true"
                                                                      }
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "×"
                                                                      )
                                                                    ]
                                                                  )
                                                                ],
                                                                2
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "modal-body"
                                                                },
                                                                [
                                                                  text.type ==
                                                                  "video"
                                                                    ? [
                                                                        _c(
                                                                          "video",
                                                                          {
                                                                            attrs: {
                                                                              controls:
                                                                                ""
                                                                            }
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "source",
                                                                              {
                                                                                attrs: {
                                                                                  src:
                                                                                    text.video,
                                                                                  type:
                                                                                    "video/mp4"
                                                                                }
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                                                                        Your browser does not support the video tag.\n                                                                                    "
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  text.type ==
                                                                  "url"
                                                                    ? [
                                                                        text.video_url !=
                                                                        ""
                                                                          ? _c(
                                                                              "iframe",
                                                                              {
                                                                                attrs: {
                                                                                  src:
                                                                                    text.video_url,
                                                                                  controls:
                                                                                    "",
                                                                                  width:
                                                                                    "100%",
                                                                                  height:
                                                                                    "250"
                                                                                }
                                                                              }
                                                                            )
                                                                          : _vm._e()
                                                                      ]
                                                                    : _vm._e()
                                                                ],
                                                                2
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "column-clear" })
                              ],
                              2
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "gallery-right-cat float-l col-12 col-sm-3 col-md-3 col-lg-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "gallery-cat-desktop width-full float-l"
                            },
                            [
                              _c(
                                "h2",
                                {
                                  staticClass:
                                    "float-l width-full heading-text-20 line-height-24 color-red font-text-bold-mont border-bottom-dddddd pb-10"
                                },
                                [_vm._v(" Select Categories ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "ul",
                                [
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        staticClass:
                                          "category category_0 active",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.getImages(0)
                                          }
                                        }
                                      },
                                      [_vm._v(" All ")]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.categoryArr, function(
                                    categoryData,
                                    index
                                  ) {
                                    return categoryData.parent_id == ""
                                      ? [
                                          _c("li", [
                                            _c(
                                              "a",
                                              {
                                                class:
                                                  "category category_" +
                                                  categoryData.value,
                                                attrs: { href: "#" },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    return _vm.getImages(
                                                      categoryData.value
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(categoryData.text) +
                                                    " "
                                                ),
                                                categoryData.cnt > 0
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "right-arrow-cat"
                                                      },
                                                      [
                                                        _c("i", {
                                                          class:
                                                            "fa fa-caret-down main_category main_category_" +
                                                            categoryData.value
                                                        })
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "ul",
                                              {
                                                staticClass:
                                                  "subcategory-gallery float-l width-full"
                                              },
                                              [
                                                _vm._l(
                                                  _vm.subCategoryArr,
                                                  function(
                                                    subCategoryData,
                                                    index
                                                  ) {
                                                    return subCategoryData.parent_id ==
                                                      categoryData.value
                                                      ? [
                                                          _c("li", [
                                                            _c(
                                                              "a",
                                                              {
                                                                class:
                                                                  "category category_" +
                                                                  subCategoryData.value,
                                                                attrs: {
                                                                  href: "#"
                                                                },
                                                                on: {
                                                                  click: function(
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.getImages(
                                                                      subCategoryData.value,
                                                                      "sub"
                                                                    )
                                                                  }
                                                                }
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      subCategoryData.text
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            )
                                                          ])
                                                        ]
                                                      : _vm._e()
                                                  }
                                                )
                                              ],
                                              2
                                            )
                                          ])
                                        ]
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ]
                          )
                        ]
                      )
                    ],
                    2
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Gallery ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15c1b052", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c1b052","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = null
// module chunks = 